import styled from '@emotion/styled'

import { CONFIG } from '@/ui/shared/styles'

const mediaQuery = {
  onlyMobile: '@media (max-width: 959px)',
} as const

export const Wrapper = styled.div`
  position: relative;
  overflow-x: auto;

  ${mediaQuery.onlyMobile} {
    padding: 0.25rem 0.25rem 2rem;
  }
`

export const List = styled.ol`
  display: inline-flex;
  gap: 1rem;

  ${CONFIG.media.lg} {
    padding: 0.25rem 0.25rem;
  }
`
